import React, { useEffect, useState } from "react";
import { PhoneNumberUtil } from "google-libphonenumber";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { checkUserAccess, sendVerificationMessage, setOnboardingPhase, updateProfileDetails } from "../../../redux/actions/authentication";
import { toast } from "react-toastify";
import CountryCode from "../../LandingPage/CountryCode";
import { countryPhoneCodes } from "../../LandingPage/countryPhoneCode";
import Successful from "./Successful";
import TechnicalFailure from "./TechnicalFailure";
import InValidFailure from "./InValidFailure";
import { SET_IS_ACTIVATION, SET_MOBILE_NUMBER } from "../../../redux/actions/types";
import { getAllPersonalizeCourses, getPersonalizeUserData } from "../../../redux/actions/personalize";
import { setActivationPhase } from "../../../redux/actions/contentPayer";
import { fetchIsUserFromBetaProduct } from "../../../redux/actions/personaliseCourse";
import LoginWithEmailModal from "../../LandingPage/LoginWithEmailModal";
import { useSearchParams } from "react-router-dom";
import CountryCode25 from "../../LandingPage25/CountryCode25";
import { Mixpanel } from "../../../config/Mixpanel";

const WhatsAppVerification = ({
    selectedCountry,
    setSelectedCountry,
    phoneNumber,
    setPhoneNumber,
    setIsWhatsApp,
    scrollRef,
    isOnboarded
}) => {
    const phoneUtil = PhoneNumberUtil.getInstance();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [textColor, setTextColor] = useState("black");
    const phoneNumberInStore = useSelector(
        (store) => store?.profileDetails?.["phone-number"]
    );
    const email = useSelector((store)=> store?.profileDetails?.email);
    const [validNumber, setValidNumber] = useState(true);
    const [renderComponent, setRenderComponent] = useState("default");
    const [disableButton , setDisableButton] = useState(false);
    const [isPhoneError , setPhoneError] = useState(false);
    const navigate = useNavigate();
    const regex = /^\d+$/;
    const [isModalEnabled , setIsModalEnabled] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams()
    

    useEffect(() => {
        if ( phoneNumberInStore !== null && phoneNumberInStore !== undefined && phoneNumberInStore.length > 0) {
            if(phoneNumberInStore[0] === '+' && regex.test(phoneNumberInStore.slice(1)) || phoneNumberInStore[0]!== '+' && regex.test(phoneNumberInStore) ){
                const number = phoneNumberInStore[0] === '+' ? phoneUtil.parseAndKeepRawInput(phoneNumberInStore) : phoneUtil.parseAndKeepRawInput('+' + phoneNumberInStore)
                const dial_code = number.getCountryCode();
                const phone_number = number.getNationalNumber();
                const country = countryPhoneCodes.find(
                    (el) => (el?.dial_code).slice(1) === dial_code.toString()
                );
                setSelectedCountry(country);
                setPhoneNumber(phone_number);
                //console.log({ dial_code , phone_number, country})
                onSubmit(country?.dial_code + phone_number, country?.code);
            } else{
                setValidNumber(false);
            }
        }
        if(window.innerWidth < 768 && scrollRef.current){
            if(scrollRef?.current){
                scrollRef?.current?.scrollIntoView({ behavior: 'smooth'})
            }
            if(scrollRef?.current){
                scrollRef?.current?.focus();
            }
        }
  }, []);

    function onSubmit(phoneNumber, countryCode) {
        if(phoneNumber[0] === '+' && regex.test(phoneNumber.slice(1))){
            if (!phoneUtil.isValidNumberForRegion(phoneUtil.parse(phoneNumber, countryCode),countryCode)){
                setValidNumber(false)
                return
            } else {
                setValidNumber(true);
                setIsLoading(true);
                setDisableButton(true);
                dispatch(
                sendVerificationMessage(
                    "one_click_verify",
                    phoneNumber,
                    (successObj) => {
                    
                    if (successObj?.result === "success") {
                        dispatch({type : SET_MOBILE_NUMBER , payload: { phone_number : phoneNumber , verified : false}});
                        setRenderComponent("success");
                    } else if (
                        successObj?.result === "failed" &&
                        successObj?.message === "OTP was not delivered"
                    ) {
                        setRenderComponent("technical");
                    }
                    else if(successObj?.result === "error" && successObj?.message === "User Already Verified"){
                        Mixpanel.people.set({
                            phone_number: phoneNumber,
                        })
                        dispatch({type : SET_MOBILE_NUMBER , payload: { phone_number :  phoneNumberInStore , verified : true}});
                        dispatch(updateProfileDetails());
                        // dispatch(fetchIsUserFromBetaProduct((successObj)=>{

                        //     const isPersonalizeUser = successObj?.data?.is_ninjacurate_user;
                        //     console.log('personalize' , isPersonalizeUser , successObj );
        
        
                        //     if(isPersonalizeUser){
                        //         dispatch(getPersonalizeUserData(
                        //             email,
                        //             (succesObj) => {
                        //               if(!succesObj?.Error){
                        //               dispatch(
                        //                 getAllPersonalizeCourses(
                        //                   succesObj?.uid,
                        //                   succesObj?.access_token,
                        //                   (result) => {
                        //                     if(result?.length){
                                                
                        //                         dispatch(setOnboardingPhase((res1)=>{
        
                        //                             dispatch(setActivationPhase((res2)=>{
                        //                                 dispatch({type : SET_IS_ACTIVATION ,payload : false});
                        //                                 navigate('/courses');
        
                        //                             } , (err2)=>{}))
        
        
                        //                         } , (err1)=>{}))
                        //                     }
                        //                     else{
                        //                         navigate("/onboarding")
                        //                     }
                        //                   },
                        //                   (err) => {
                        //                     toast.error(err);
                        //                   }
                        //                 )
                        //               );
                        //                 }}))
                        //     }
                        //     else{
                        //         dispatch(checkUserAccess((successObj)=>{ 
                        //             if(successObj?.is_onboarded){
                        //             navigate('/courses')}
                        //             else{
                        //             navigate('/onboarding')
                        //             }  }))
                        //     }
        
        
        
                        //     } , (errorObj)=>{}))

                            dispatch(checkUserAccess((successObj)=>{ 
                                if(successObj?.is_onboarded){
                                    if(searchParams.get("course")){
                                        navigate(`/popular-course/${searchParams?.get("course")}`);
                                      }
                                      else{
                                 navigate('/courses')}
                                      }
                                 else{
    
                                    if(searchParams.get("course")){
                                        navigate(`/onboarding/${searchParams?.get("course")}`);
                                      }
                                      else{
                                        navigate('/onboarding')
                                      }
                               
                              }  }))
                      
                    } 
                    else if(successObj?.result === "failed" && successObj?.message === 'Phone already in use')
                    {
                        toast.error(successObj?.message)
                        setPhoneError(true);
                    }
                    else {
                        setRenderComponent("InValidWhatsApp");
                    }
                    setIsLoading(false);
                    setDisableButton(false);
                    },
                    (errorObj) => {
                    toast.error(errorObj.message);
                    setIsLoading(false);
                    setDisableButton(false);
                    }
                )
                );
            }}
        else{
            setValidNumber(false);
            //console.log('regex error');
        }
    }

    if (renderComponent === "default") {
        return (
            <div className="w-full flex flex-col md:flex-col">
            {/* <h2 className="text-xl font-semibold text-white" ref={scrollRef}>Mobile Verification</h2> */}
            {/* <h3 className="font-semibold text-white/80">Verify your number to unlock free access.</h3> */}
            <p className="text-left text-[24px] md:text-[32px] font-semibold leading-[130%] mt-11 text-white">Verify Your Number</p>
            {isPhoneError && <span className="text-[#E06064] ml-1 font-normal italic text-[14px] ">Already in use, try to login</span>}
            {!validNumber && (<span className="text-sm font-medium text-[#E5303E]">Enter a valid WhatsApp Number</span>)}
            <div className="mt-1 flex w-full flex-col items-center justify-center text-gray-500">
                <div className="mb-2  h-12 flex flex-row w-full items-end gap-2 md:flex-row md:items-end md:justify-center">
                    <div className="h-12">
                        <CountryCode25
                            selected={selectedCountry}
                            setSelected={setSelectedCountry}
                            disable={false}
                        />
                        {!validNumber && (<span className="hidden md:inline-block"><br /></span>)}
                    </div>
                    <div className="flex-1">
                        <input
                            id="phone-number"
                            name="phone"
                            type="tel"
                            onChange={(e) =>{ setPhoneError(false); setPhoneNumber(e.target.value) }}
                            pattern="[0-9.]+"
                            required
                            ref={scrollRef}
                            value={phoneNumber}
                            placeholder="Phone Number"
                            disabled={false}
                            className={`h-12 w-full appearance-none rounded-lg border-none bg-[#07274b] px-3   
                                text-white placeholder:text-sm placeholder:font-normal placeholder:text-white/50 focus:z-10 focus:border-[#7FC241] focus:outline-none focus:ring-[#7FC241] disabled:bg-[#475a73] sm:text-sm`}
                  />
                    
                        
                    </div>
                </div>
                
                <button className="mt-4 w-full h-12 rounded-lg  bg-[#7FC241] text-center text-[16px] font-semibold text-[#121212] disabled:opacity-50"
                    disabled={disableButton || phoneNumber.length === 0}
                    onClick={(e) =>
                    onSubmit(
                        selectedCountry?.dial_code + phoneNumber,
                        selectedCountry?.code
                    )
                    }
                >
                    Register
                </button>
                
                <div className="text-[12px] text-left italic font-light leading-[130%] text-white mt-1">This helps us personalise your career path and send you future updates.</div>
            </div>
            {isPhoneError && <div className="mt-4 text-[16px] text-[#7FC241] text-center font-semibold underline underline-offset-2 cursor-pointer" onClick={(e)=> setIsModalEnabled(true)}>Login With Email</div>}
            {isModalEnabled && <LoginWithEmailModal isModalEnabled={isModalEnabled} setIsModalEnabled={setIsModalEnabled}/>}
        </div>
        );
    } else if (renderComponent === "success") {
        return (
            <Successful
                selectedCountry={selectedCountry}
                setSelectedCountry={setSelectedCountry}
                phoneNumber={phoneNumber}
                setPhoneNumber={setPhoneNumber}
                setRenderComponent={setRenderComponent}
                setIsWhatsApp={setIsWhatsApp}
                scrollRef={scrollRef}
            />)
    } else if (renderComponent === "technical") {
        return (
            <TechnicalFailure
                selectedCountry={selectedCountry}
                setSelectedCountry={setSelectedCountry}
                phoneNumber={phoneNumber}
                setPhoneNumber={setPhoneNumber}
                setRenderComponent={setRenderComponent}
                setIsWhatsApp={setIsWhatsApp}
                scrollRef={scrollRef}
            />
        );
    } else {
        return (
            <InValidFailure
                selectedCountry={selectedCountry}
                setSelectedCountry={setSelectedCountry}
                phoneNumber={phoneNumber}
                setPhoneNumber={setPhoneNumber}
                setRenderComponent={setRenderComponent}
                setIsWhatsApp={setIsWhatsApp}
                scrollRef={scrollRef}
            />
        )
    }
}

export default WhatsAppVerification;
